export const MARCA_BLANCA_MAX_UNITS = 5;

const toUnits = (value: any): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const getCartLineUnits = (item: any): number => {
  if (Array.isArray(item?.references) && item.references.length > 0) {
    return item.references.reduce(
      (total: number, reference: any) => total + toUnits(reference?.quantity),
      0,
    );
  }
  return toUnits(item?.quantity);
};

export const getCartUnits = (cartInfo: any): number => {
  if (!Array.isArray(cartInfo)) return 0;
  return cartInfo.reduce(
    (total: number, item: any) => total + getCartLineUnits(item),
    0,
  );
};

export const getUnitsExcludingLine = (cartInfo: any, lineId: any): number => {
  if (!Array.isArray(cartInfo)) return 0;
  return getCartUnits(cartInfo.filter((item: any) => item?.id !== lineId));
};

export const exceedsMarcaBlancaLimit = (
  cartInfo: any,
  requestedUnits: any,
  maxUnits: number,
): boolean =>
  getCartUnits(cartInfo) + toUnits(requestedUnits) > maxUnits;
